export default "__VITE_ASSET__1b94154e__"